// Backoffice (Vite + React) Sentry init. Vite exposes env vars via
// import.meta.env; the kill-switch + DSN are the same pattern as web.

import * as Sentry from '@sentry/react';

// Inline the minimal types we need so we don't depend on @sentry/core directly.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ErrorEvent = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventHint = any;

const PII_KEY_RE = /email|phone|first_?name|last_?name|address|card|cvv|stripe_pi|payment_intent/i;

function maskPiiKeys(obj: Record<string, unknown>): void {
  for (const k of Object.keys(obj)) {
    const v = obj[k];
    if (PII_KEY_RE.test(k)) {
      obj[k] = '[Filtered]';
    } else if (v && typeof v === 'object' && !Array.isArray(v)) {
      maskPiiKeys(v as Record<string, unknown>);
    }
  }
}

function stripPii(event: ErrorEvent, _hint: EventHint): ErrorEvent | null {
  if (event.request?.cookies) delete event.request.cookies;
  if (event.request?.headers) {
    delete event.request.headers['cookie'];
    delete event.request.headers['authorization'];
  }
  if (event.user) {
    delete event.user.email;
    delete event.user.username;
    delete event.user.ip_address;
  }
  if (event.extra) maskPiiKeys(event.extra);
  if (event.contexts) maskPiiKeys(event.contexts as Record<string, unknown>);
  return event;
}

const enabled = import.meta.env.VITE_ANALYTICS_ENABLED === 'true';
const dsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '';

export function initBackofficeSentry(): void {
  if (!enabled || !dsn) return;
  Sentry.init({
    dsn,
    environment: 'production',
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
    beforeSend: stripPii,
  });
}
